export const CoreStakeholdersName = 'CoreStakeholders';
